module.exports = __webpack_public_path__ + "img/Bn2.34742f15.png";